import Styles from "./ViewFinalizeTerms.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { formatDate, formatSlotTime } from "../../../../helpers/dateFormat";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "../../../../assets/images/info.svg";

const ViewFinalizeTerms = ({
  open,
  handleClose,
  data,
  drafted,
  useSecondaryAccent = false,
}) => {
  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole,
  )?.toLowerCase();

  const myListingKey =
    user === "consumer" ? "capacityConsumer" : "capacityGenerator";
  const counterListingKey =
    user === "consumer" ? "capacityGenerator" : "capacityConsumer";

  const myListing = {
    companyName: data[myListingKey]?.companyName,
    paymentSecurity: data[myListingKey]?.paymentSecurity,
    initialMargin: data[myListingKey]?.initialMargin,
    emd: data[myListingKey]?.emd,
  };
  const counterListing = {
    companyName: data[counterListingKey]?.companyName,
    paymentSecurity: data[counterListingKey]?.paymentSecurity,
    initialMargin: data[counterListingKey]?.initialMargin,
    emd: data[counterListingKey]?.emd,
  };

  const HighlightIfDifferent = ({
    value,
    compareWith,
    children,
    className = "",
  }) => {
    const isDifferent = value !== compareWith;
    return (
      <span
        className={isDifferent ? `${Styles.greenText} ${className}` : className}
      >
        {children}
      </span>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div
          className={`popupModal ${Styles.modalMainCont} ${
            useSecondaryAccent ? "secondaryAccent" : ""
          }`}
        >
          <div className="modalHeading">
            <div>Terms and Conditions</div>
            <Close
              onClick={handleClose}
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          <div className={Styles.termsMainContainer}>
            <div className={Styles.tableHeadingCustom}>
              <div>Category</div>
              <div>My Listing</div>
              <div>Counterparty Listing</div>
              <div>{drafted ? "Drafted" : "Final"} Values</div>
            </div>
            <div className={Styles.tableDetailsMainContCustom}>
              <div
                style={{ paddingBottom: "10px" }}
                className={Styles.sectionBox}
              >
                <div className={Styles.row}>
                  <div>Name</div>
                  <div style={{ fontWeight: "600" }}>
                    {" "}
                    {data[myListingKey]?.generatorName ||
                      data[myListingKey]?.consumerName}
                  </div>
                  <div style={{ fontWeight: "600" }}>
                    {data[counterListingKey]?.generatorName ||
                      data[counterListingKey]?.consumerName}
                  </div>
                  <div></div>
                </div>

                {/* <div className={Styles.row}>
                  <div>
                    EMD (₹/MW)
                    <Tooltip
                      title={
                        <span style={{ whiteSpace: "pre-line" }}>
                          <strong>Seller’s EMD:</strong> An amount of ₹30,000
                          per MW or ₹1,00,000, whichever is lower, shall be
                          deducted.
                          <br />
                          <br />
                          <strong>Buyer's EMD:</strong> 0
                        </span>
                      }
                    >
                      <IconButton>
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div>{myListing.emd} </div>
                  <div>{counterListing.emd} </div>
                  <div>
                    <HighlightIfDifferent
                      value={data.emd}
                      compareWith={myListing.emd}
                    >
                      {data.emd}
                    </HighlightIfDifferent>
                  </div>
                </div>
                <div className={Styles.row}>
                  <div>
                    Initial Margin (%)
                    <Tooltip
                      title={
                        <span style={{ whiteSpace: "pre-line" }}>
                          <strong>Buyer’s Initial Margin</strong>: The
                          percentage of the total transaction value required to
                          be deposited by the Buyer for a single day.
                          <br />
                          <br />
                          <strong>Seller’s Initial Margin</strong>: A fixed
                          margin equivalent to 20% of the total transaction
                          value, to be deposited by the Seller for a single day.
                        </span>
                      }
                    >
                      <IconButton>
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div>{myListing.initialMargin}</div>
                  <div>{counterListing.initialMargin}</div>
                  <div>
                    <HighlightIfDifferent
                      value={data.initialMargin}
                      compareWith={myListing.initialMargin}
                    >
                      {data.initialMargin}
                    </HighlightIfDifferent>
                  </div>
                </div>
                <div className={Styles.row}>
                  <div>
                    Payment Security (# Days)
                    <Tooltip
                      title={
                        <span style={{ whiteSpace: "pre-line" }}>
                          <strong>Buyer’s Payment Security:</strong> Calculated
                          as the Buyer’s Initial Margin multiplied by the
                          transaction value for one trading day and the number
                          of days of payment security.
                          <br />
                          <br />
                          <strong>Seller’s Payment Security:</strong> Sellers’
                          initial margin will be considered as payment security.
                        </span>
                      }
                    >
                      <IconButton>
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div>{myListing.paymentSecurity} </div>
                  <div>{counterListing.paymentSecurity} </div>
                  <div>
                    <HighlightIfDifferent
                      value={data.paymentSecurity}
                      compareWith={myListing.paymentSecurity}
                    >
                      {data.paymentSecurity}
                    </HighlightIfDifferent>
                  </div>
                </div> */}
              </div>
              {data.bilateralConnections.map((matchSlot, idx) => {
                if (matchSlot.status === "REJECTED") return null;
                let myKey =
                  user === "consumer" ? "consumerSlot" : "generatorSlot";
                let counterKey =
                  user === "consumer" ? "generatorSlot" : "consumerSlot";

                return (
                  <div className={Styles.reqSection} key={matchSlot.id}>
                    <div className={Styles.reqHeader}>
                      Requisition {idx + 1}
                    </div>
                    <div className={Styles.row}>
                      <div>Energy Rate (₹/kWh)</div>
                      <div style={{ fontWeight: 500 }}>
                        {matchSlot[myKey]?.energyRateType === "FIXED"
                          ? `${
                              matchSlot[myKey].landingCost ||
                              matchSlot[myKey].sellingCost ||
                              0
                            }`
                          : matchSlot[myKey]?.energyRateType === "DAM_PLUS"
                            ? `DAM+${
                                matchSlot[myKey].landingCost ||
                                matchSlot[myKey].sellingCost ||
                                0
                              }`
                            : `DAM-${
                                matchSlot[myKey].landingCost ||
                                matchSlot[myKey].sellingCost ||
                                0
                              }`}
                      </div>
                      <div className={Styles.orangeText}>
                        {matchSlot[counterKey]?.energyRateType === "FIXED"
                          ? `${
                              matchSlot[counterKey].landingCost ||
                              matchSlot[counterKey].sellingCost ||
                              0
                            }`
                          : matchSlot[counterKey]?.energyRateType === "DAM_PLUS"
                            ? `DAM+${
                                matchSlot[counterKey].landingCost ||
                                matchSlot[counterKey].sellingCost ||
                                0
                              }`
                            : `DAM-${
                                matchSlot[counterKey].landingCost ||
                                matchSlot[counterKey].sellingCost ||
                                0
                              }`}
                      </div>

                      <div>
                        <HighlightIfDifferent
                          value={
                            matchSlot?.energyRateType === "FIXED"
                              ? `${matchSlot.amount}`
                              : matchSlot?.energyRateType === "DAM_PLUS"
                                ? `DAM+${matchSlot.amount}`
                                : `DAM-${matchSlot.amount}`
                          }
                          compareWith={
                            matchSlot[myKey]?.energyRateType === "FIXED"
                              ? `${
                                  matchSlot[myKey].landingCost ||
                                  matchSlot[myKey].sellingCost ||
                                  0
                                }`
                              : matchSlot[myKey]?.energyRateType === "DAM_PLUS"
                                ? `DAM+${
                                    matchSlot[myKey].landingCost ||
                                    matchSlot[myKey].sellingCost ||
                                    0
                                  }`
                                : `DAM-${
                                    matchSlot[myKey].landingCost ||
                                    matchSlot[myKey].sellingCost ||
                                    0
                                  }`
                          }
                        >
                          {matchSlot?.energyRateType === "FIXED"
                            ? `${matchSlot.amount}`
                            : matchSlot?.energyRateType === "DAM_PLUS"
                              ? `DAM+${matchSlot.amount}`
                              : `DAM-${matchSlot.amount}`}{" "}
                        </HighlightIfDifferent>
                      </div>
                    </div>
                    <div className={Styles.row}>
                      <div>Quantity (MW)</div>
                      <div style={{ fontWeight: 500 }}>
                        {matchSlot[myKey].sellEnergy ||
                          matchSlot[myKey].purchaseEnergy}{" "}
                      </div>
                      <div className={Styles.orangeText}>
                        {matchSlot[counterKey].sellEnergy ||
                          matchSlot[counterKey].purchaseEnergy}{" "}
                      </div>
                      <div>
                        <HighlightIfDifferent
                          value={matchSlot.quantity}
                          compareWith={
                            matchSlot[myKey].sellEnergy ||
                            matchSlot[myKey].purchaseEnergy
                          }
                        >
                          {matchSlot.quantity}
                        </HighlightIfDifferent>
                      </div>
                    </div>
                    <div className={Styles.row}>
                      <div>Start Date</div>
                      <div>{formatDate(matchSlot[myKey]?.dateStartAt)}</div>
                      <div>
                        {formatDate(matchSlot[counterKey]?.dateStartAt)}
                      </div>

                      <div>
                        <HighlightIfDifferent
                          value={formatDate(matchSlot.dateStartAt)}
                          compareWith={formatDate(
                            matchSlot[myKey]?.dateStartAt,
                          )}
                        >
                          {formatDate(matchSlot.dateStartAt)}
                        </HighlightIfDifferent>
                      </div>
                    </div>
                    <div className={Styles.row}>
                      <div>End Date</div>
                      <div>{formatDate(matchSlot[myKey]?.dateEndAt)}</div>
                      <div>{formatDate(matchSlot[counterKey]?.dateEndAt)}</div>
                      <div>
                        <HighlightIfDifferent
                          value={formatDate(matchSlot.dateEndAt)}
                          compareWith={formatDate(matchSlot[myKey]?.dateEndAt)}
                        >
                          {formatDate(matchSlot.dateEndAt)}
                        </HighlightIfDifferent>
                      </div>
                    </div>
                    <div className={Styles.row}>
                      <div>Start Time</div>
                      <div>{formatSlotTime(matchSlot[myKey]?.slotStartAt)}</div>
                      <div>
                        {formatSlotTime(matchSlot[counterKey]?.slotStartAt)}
                      </div>
                      <div>
                        <HighlightIfDifferent
                          value={formatSlotTime(matchSlot.slotStartAt)}
                          compareWith={formatSlotTime(
                            matchSlot[myKey]?.slotStartAt,
                          )}
                        >
                          {formatSlotTime(matchSlot.slotStartAt)}
                        </HighlightIfDifferent>
                      </div>
                    </div>
                    <div className={Styles.row}>
                      <div>End Time</div>
                      <div>{formatSlotTime(matchSlot[myKey]?.slotEndAt)}</div>
                      <div>
                        {formatSlotTime(matchSlot[counterKey]?.slotEndAt)}
                      </div>
                      <div>
                        <HighlightIfDifferent
                          value={formatSlotTime(matchSlot.slotEndAt)}
                          compareWith={formatSlotTime(
                            matchSlot[myKey]?.slotEndAt,
                          )}
                        >
                          {formatSlotTime(matchSlot.slotEndAt)}
                        </HighlightIfDifferent>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewFinalizeTerms;
